<div class="drp">
  <button type="button" class="drp-input" (click)="toggle()">
    <span class="icon" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path
          d="M7 3v3M17 3v3M4 7h16v14H4z"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M4 11h16" fill="none" stroke="currentColor" stroke-width="2" />
      </svg>
    </span>
    <span class="value">{{ displayValue }}</span>
    <span class="caret" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </span>
  </button>

  <div class="drp-backdrop" *ngIf="open" (click)="close()"></div>
  <section class="drp-popover" *ngIf="open" (click)="$event.stopPropagation()">
    <header class="drp-header">
      <button type="button" class="nav" aria-label="Mês anterior" (click)="prevMonth()">‹</button>
      <div class="month">{{ monthLabel }}</div>
      <button type="button" class="nav" aria-label="Próximo mês" (click)="nextMonth()">›</button>
    </header>

    <div class="weekdays">
      <span>SEG</span><span>TER</span><span>QUA</span><span>QUI</span><span>SEX</span><span>SAB</span><span>DOM</span>
    </div>

    <div class="grid">
      <button
        type="button"
        class="day"
        *ngFor="let day of daysGrid()"
        [disabled]="!day || (day && isDisabled(day))"
        [class.in-range]="day && isInRange(day)"
        [class.edge]="day && isRangeEdge(day)"
        (click)="day && select(day)"
      >
        {{ day ? day.getDate() : '' }}
      </button>
    </div>
  </section>
</div>

